import * as actionTypes from "./actionTypes";
import store from "../store";
import {
  getECCCFormData,
  getInvoiceECCCFormData,
  getEntrySummaryForm,
} from "../api/getEntrySummaryData";
import { convertInvoiceECCCItems } from "../components/entrySummaryForms/util/assignValues";
import {
  initializeECCC,
  initializeInvoiceECCC,
  initializeECCCFlag,
} from "./initializeValues";
import {
  getInitialECCC,
  getInitialECCC1,
} from "../components/entrySummaryForms/util/initialValues";

export const toggleECCC = (
  merchandiseId,
  loading,
  lineItemIndex,
  pgaPayload,
  invoiceId
) => ({
  type: actionTypes.TOGGLE_ECCC(lineItemIndex),

  payload: {
    merchandiseId,
    loading,
    lineItemIndex,
    pgaPayload,
    invoiceId,
  },
});
const convertECCCItems = (PGAItems, programttype) => {
  let result =
  programttype !== "Wildlife Enforcement"
  ? getInitialECCC(programttype)
  : getInitialECCC1(programttype);

  PGAItems.elements.forEach((item) => {
    result["elements"].map((item2) => {
      if (item2.elementName == item.elementName) {
        item2.uiVals = item.uiVals || [{ id: 0, value: "" }];
      }
    });
  });
  result.pga.cbsaPgaSubProgramType = programttype;
  return result;
};

export function toggleECCCForm(
  merchandiseId,
  lineItemIndex,
  pgaPayload,
  invoiceId,
  pgaProgram
) {
  store.dispatch(
    toggleECCC(merchandiseId, true, lineItemIndex, pgaPayload, invoiceId)
  );

  getEntrySummaryForm(window.shipmentId)
    .then((response) => {
      store.dispatch(
        initializeECCCFlag(
          response.data.eventMessage.descriptionOfMerchandise
            ?.merchandiseLineItems
        )
      );

      const responseData =
        response.data.eventMessage.descriptionOfMerchandise
          ?.merchandiseLineItems[lineItemIndex].pgaDetails?.pgaDetails;

      const getPgaType = (responseData) => {
        if (Array.isArray(responseData) && responseData.length) {
          for (let i = 0; i < responseData.length; i++) {
            if (responseData[i].pga.cbsaPgaType == "ECCC") {
              return responseData[i].pga.cbsaPgaSubProgramType;
            }
          }
          return undefined;
        } else {
          return undefined;
        }
      };
      let programType = getPgaType(responseData) || pgaProgram;
      if( (programType||"").includes("Wildlife Enforcement")){
        programType = "Wildlife Enforcement"
      }

      const initialData =
        programType !== "Wildlife Enforcement"
          ? getInitialECCC(programType)
          : getInitialECCC1(programType);

      if (responseData) {
        for (let i = 0; i < responseData.length; i++) {
          if (responseData[i].pga.cbsaPgaType === "ECCC") {
            const data = convertECCCItems(responseData[i], programType);
            return store.dispatch(initializeECCC(lineItemIndex, data));
          }
        }
        return store.dispatch(initializeECCC(lineItemIndex, initialData));
      } else {
        return store.dispatch(initializeECCC(lineItemIndex, initialData));
      }

      // if (findEcccValue) {
      //   findEcccValue.map((values) => {
      //     if (values.pga.cbsaPgaType === "ECCC") {
      //       return store.dispatch(
      //         initializeECCC(
      //           lineItemIndex,
      //           convertECCCItems(
      //             values,
      //             merchandiseId,
      //             pgaPayload?.cbsaPgaSubProgramType,
      //             lineItemIndex
      //           )
      //         )
      //       );
      //     }
      //   });
      // } else if (
      //   findEcccValue &&
      //   findEcccValue.length < 2 &&
      //   findEcccValue[0] !== "ECCC"
      // ) {
      //   getECCCFormData(merchandiseId, pgaPayload).then((response) => {
      //     return store.dispatch(
      //       initializeECCC(
      //         lineItemIndex,
      //         convertECCCItems(
      //           response.data.eventMessage.pgaDetails.pgaDetails[0],
      //           merchandiseId,
      //           pgaPayload?.cbsaPgaSubProgramType
      //         )
      //       )
      //     );
      //   });
      // } else {
      //   getECCCFormData(merchandiseId, pgaPayload).then((response) => {
      //     return store.dispatch(
      //       initializeECCC(
      //         lineItemIndex,
      //         convertECCCItems(
      //           response.data.eventMessage.pgaDetails.pgaDetails[0],
      //           merchandiseId,
      //           pgaPayload?.cbsaPgaSubProgramType
      //         )
      //       )
      //     );
      //   });
      // }
    })

    .catch((err) => {
      console.error("ECCC Error", err);
      let error = {
        ECCError: err,
      };
      return store.dispatch(
        initializeECCC(lineItemIndex, {
          error: `ERROR: Could not retrieve ECCC Certification for the associated HTS and Merchandise ID ${merchandiseId} ${error}`,
        })
      );
    });
  getInvoiceECCCFormData(invoiceId, pgaPayload)
    .then((response) => {
      return store.dispatch(
        initializeInvoiceECCC(
          lineItemIndex,
          convertInvoiceECCCItems(
            response.data.eventMessage.pgaDetails.pgaDetails,
            invoiceId
          )
        )
      );
    })

    .catch((err) => {
      console.error("ECCC Error", err);
      let error = {
        ECCError: err,
      };
      return store.dispatch(
        initializeInvoiceECCC(lineItemIndex, {
          error: `ERROR: Could not retrieve ECCC Certification for the associated HTS and Merchandise ID ${invoiceId} ${error}`,
        })
      );
    });
}

// export function toggleInvoiceECCCForm(
//     merchandiseId,
//     invoiceId,
//     lineItemIndex,
//     pgaPayload
// ) {
//     store.dispatch(toggleInvoiceECCC(invoiceId, true, lineItemIndex, pgaPayload))
//     getInvoiceECCCFormData(invoiceId, pgaPayload)
//         .then(response => {
//             return store.dispatch(
//                 initializeECCC(
//                     lineItemIndex,
//                     convertInvoiceECCCItems(response.data.eventMessage.pgaDetails.pgaDetails, invoiceId)
//                 )
//             )
//         })
//
//         .catch(err => {
//             console.error('ECCC Error', err)
//             let error = {
//                 ECCError: err
//             }
//             return store.dispatch(
//                 initializeECCC(
//                     lineItemIndex,
//                     {
//                         error: `ERROR: Could not retrieve ECCC Certification for the associated HTS and Merchandise ID ${merchandiseId} ${error}`
//                     })
//             )
//         })
// }

export function updateECCCField(lineItemIndex, field, payload, level) {
  return {
    type: actionTypes.UPDATE_ECCC_FIELD(lineItemIndex),
    payload,
    field,
    level,
  };
}

export function saveECCCField(
  merchandiseId,
  lineItemIndex,
  field,
  level,
  invoiceId
) {
  return {
    type: actionTypes.SAVE_ECCC_FIELD(lineItemIndex),
    field,
    merchandiseId,
    level,
    invoiceId,
  };
}
//
// export function updateInvoiceECCCField(lineItemIndex, field, payload) {
//     return {
//         type: actionTypes.UPDATE_INVOICE_ECCC_FIELD(lineItemIndex),
//         payload,
//         field
//     }
// }

// export function saveInvoiceECCCField(merchandiseId, lineItemIndex, field) {
//     return {
//         type: actionTypes.SAVE_INVOICE_ECCC_FIELD(lineItemIndex),
//         field,
//         merchandiseId
//     }
// }
